//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { env, Native } from '@hb/hbridge';
import { getPowerConfig, powerIsOpen } from '@/api/power';
import { Toast } from 'vux';
import TQ from '@/utils/tianqi';
import WarmUp from '../components/WarmUp';
import Diversion from '../components/Diversion';
import ErrorPage from '../components/ErrorPage';
import { WARMUP, DIVERSION } from '../const';


export default {
  components: {
    WarmUp,
    Diversion,
    ErrorPage,
    Toast,
  },
  data() {
    const { source, appversion } = this.$route.query;
    return {
      us: {},
      componentId: '',
      params: {},
      data: null,
      source,
      appversion,
      showToast: false,
      toastMessage: '',
    };
  },
  async mounted() {
    let _data;
    try {
      const { token } = await Native.getTokenAndKey();
      const {
        cityCode, adCode, lng, lat, userGuid
      } = await Native.getCityInfo();
      // const token = '9de978d7af4e5ecb106cd3f6ac036b86';
      // const cityCode = '021';
      // const adCode = '310112';
      // const lng = '1';
      // const lat = '2';
      // const userGuid = '3';
      this.$store.commit('SET_TQ_PARAMS', {
        cityCode, adCode, lng, lat, userGuid
      });

      this.$store.commit('SET_WEBVIEW_TOKEN', token);
      if (token) {
        this.params.token = token;
      } else throw new Error('获取登录信息失败');

      if (adCode && cityCode) {
        Object.assign(this.params, { adCode, cityCode });
      } else throw new Error('获取定位信息失败');
      if (env.isEasyBikeApp || env.isIOS) {
        _data = await this.getPowerConfig(WARMUP);
        this.componentId = 'WarmUp';
      } else if (env.isAliMP || env.isAliMPMonitor) {
      // 判断城市配置是否上架
        const isOpen = await powerIsOpen(this.params);
        // 是否从平台小程序跳转
        if (isOpen && this.source === 'base') {
          _data = await this.getPowerConfig(DIVERSION);
          this.componentId = 'Diversion';
        }
        // 如果未开城或者是从换电小程序进来
        if (!isOpen || this.source === 'power') {
          _data = await this.getPowerConfig(WARMUP);
          this.componentId = 'WarmUp';
        }
      } else {
        this.componentId = 'ErrorPage';
      }
      this.data = {
        adCode, cityCode, token, ..._data, appversion: this.appversion
      };
    } catch (err) {
      this.showToast = true;
      this.componentId = 'ErrorPage';
      this.toastMessage = err.message;
    }
  },
  methods: {
    getPowerConfig(citytype) {
      this.$store.commit('SET_TQ_PARAMS', {
        citytype
      });
      this.tqHandle();
      return getPowerConfig({ ...this.params, type: citytype });
    },
    tqHandle() {
      TQ.pageView({
        pageId: 'usergrowth_power_alipay',
        categoryId: 'switchpower',
        businessInfo: {
          citytype: this.$store.state.user.tianqiParams.citytype
        }
      });
    }
  },
  beforeRouteLeave(to, from, next) {
    TQ.pageViewOut({
      pageId: 'usergrowth_power_alipay',
      categoryId: 'switchpower',
      businessInfo: {
        citytype: this.citytype
      }
    });
    next();
  }
};
